<script>
    // @ts-nocheck
    import {
        BackDrop,
        Modal,
        Typography,
        TertiaryButton,
        Spinner,
        Button,
    } from '$lib/components/UI'
    import { PersonAddOutline } from '$lib/components/Icons'
    import { fakeFetch } from '$lib/utils'
    import user from '$lib/stores/user'
    import { API_URL } from '$lib/conf'
    import EmployeCard from '$lib/custom/components/EmployeCard.svelte'
    import Empleado from '$lib/custom/components/Empleado.svelte'
    import AddCircle from '$lib/components/Icons/AddCircle.svelte'
    let loading = false
    let showModalAdd = false
    let showModalEmploye = false
    let currentEmpleado = {}
    let formData = {}
    let auxEmployeData = {}
    let editable = false
    let validations = {}

    const sectionSchema = {
        Habilitado: {
            title: 'Mis empleados',
            desc: 'A continuación puede ver, modificar y agregar empleados que trabajen desde las instalaciones de La Caja.',
        },
        'En aprobación': {
            title: 'Empleados en aprobación',
            desc: 'Aqui verá los empleados agregados que estén pendientes de aprobación.',
        },
        Deshabilitado: {
            title: 'Empleados deshabilitados',
            desc: 'Mis empleados deshabilitados, a continuación haga click en el empleado para más información.',
        },
    }
    function getEmployes() {
        return user.isLogined()
            ? user.fetch(`${API_URL}/employes/${user.currentAccount}`)
                .then(async (r) => await r.json())
            : employes
    }
    let employes = getEmployes()

    function addEmploye() {
        showModalAdd = true
        currentEmpleado = {}
    }

    function viewEmploye() {
        showModalEmploye = true
    }

    async function updateEmploye() {
        if (user.isLogined()) {
            loading = true
            await user.fetch(`${API_URL}/employes/${user.currentAccount}`, {
                method: 'PUT',
                body: JSON.stringify(currentEmpleado)
            }).then(async (r) => {
                showModalEmploye = false
                editable = false
                loading = false
                return await r.json()
            })
            employes = getEmployes().then((r) => {
                auxEmployeData = {}
                currentEmpleado = {}
                return r
            })
        }
    }

    async function toggleEmployeStatus() {
        if (user.isLogined()) {
            loading = true
            await user.fetch(`${API_URL}/employes/${user.currentAccount}`, {
                method: 'PUT',
                body: JSON.stringify({
                    cuil: currentEmpleado.cuil,
                    active: !currentEmpleado.active,
                })
            }).then(async (r) => {
                showModalEmploye = false
                loading = false
                return await r.json()
            })
            employes = getEmployes().then((r) => {
                currentEmpleado = {}
                auxEmployeData = {}
                return r
            })
        }
    }

    async function sendEmploye() {
        if (user.isLogined()) {
            loading = true
            await user.fetch(`${API_URL}/employes/${user.currentAccount}`, {
                method: 'POST',
                body: JSON.stringify(formData),
            }).then(async (r) => {
                showModalAdd = false
                loading = false
                return await r.json()
            })
            employes = getEmployes().then((r) => {
                formData = {}
                return r
            })
        }
    }

    async function sendBajaPermanente() {
        if (user.isLogined()) {
            loading = true
            await user.fetch(`${API_URL}/employes/${user.currentAccount}`, {
                method: 'PUT',
                body: JSON.stringify({
                    cuil: currentEmpleado.cuil,
                    baja_permanente: true,
                    motivo_deshabilitacion:
                        currentEmpleado.motivo_deshabilitacion,
                })
            }).then(async (r) => {
                showModalEmploye = false
                loading = false
                return await r.json()
            })
            employes = getEmployes().then((r) => {
                currentEmpleado = {}
                auxEmployeData = {}
                return r
            })
        }
    }

    function areEquals(a, b, keys = []) {
        if (keys?.length === 0) {
            keys = Object.keys(a).filter((k) => k in b)
        }
        return keys.map((k) => a[k] == b[k]).every((x) => x)
    }

    function categorize(input) {
        return input.reduce(
            (acc, i) => ({
                ...acc,
                [i.lfstate]: i.lfstate in acc ? [...acc[i.lfstate], i] : [i],
            }),
            {}
        )
    }

    let significativeFields = [
        'cuil',
        'nombre',
        'apellido',
        'clave_de_alta_temprana',
        'cobertura_de_riesgo_de_trabajo',
        'active',
        'cuenta_corriente',
    ]

    $: changeFormData = !areEquals(
        auxEmployeData,
        currentEmpleado,
        significativeFields
    )

    $: validForm = Object.values(validations).reduce((r, x) => r && x, true)

    $: validData = significativeFields
        .filter(
            (f) =>
                ![
                    'constancia_pago_remuneracion',
                    'copia_pago_seguridad',
                    'active',
                ].includes(f)
        )
        .every((f) =>
            f in currentEmpleado ? currentEmpleado[f]?.length > 2 : false
        )

    $: updateDocs = Object.entries(currentEmpleado)
        .filter(([k]) =>
            ['constancia_pago_remuneracion', 'copia_pago_seguridad'].includes(k)
        )
        .some(([_, v]) => v?.length > 0)
    $: console.log({
        validForm,
        changeFormData,
        auxEmployeData,
        currentEmpleado,
        formData,
    })
</script>

<div
    style="width: 100%; padding: 25px 68px 68px 68px;min-height: calc(100% - 70px); position:relative"
>
    {#await employes}
        <div class="dg">
            <Spinner />
        </div>
    {:then data}
        {@const allEmployes = categorize(data)}
        {#each Object.entries(sectionSchema) as [lfstate, { title, desc }] (lfstate)}
            {#if lfstate in allEmployes || lfstate === 'Habilitado'}
                <div class="title">
                    <span>
                        <Typography type="h2" style="margin: 0; padding: 0"
                            >{title}</Typography
                        >
                        <Typography
                            type="body"
                            style="margin: 0; padding: 0"
                            color="grey-800">{desc}</Typography
                        >
                    </span>
                    {#if lfstate === 'Habilitado'}
                        <span>
                            <Button
                                size="small"
                                style="padding: 4px 8px; gap: 4px; width: 215px"
                                on:click={addEmploye}
                            >
                                <PersonAddOutline color="#FFF" />
                                <Typography type="body" color="white"
                                    >Agregar empleado</Typography
                                >
                            </Button>
                        </span>
                    {/if}
                </div>
                {#if allEmployes[lfstate]?.length}
                    <div class="container">
                        {#each allEmployes[lfstate] as employe, i (i)}
                            <EmployeCard
                                on:click={() => {
                                    currentEmpleado = structuredClone(employe)
                                    auxEmployeData = structuredClone(employe)
                                    viewEmploye()
                                }}
                                {...employe}
                                {i}
                            />
                        {/each}
                    </div>
                {:else}
                    <div class="dg">
                        <Typography
                            type="h3"
                            style="margin: 0; padding: 0"
                            color="grey-400">No hay empleados</Typography
                        >
                        <TertiaryButton
                            icon={AddCircle}
                            label="Agregar empleado"
                            on:click={addEmploye}
                        />
                    </div>
                {/if}
            {/if}
        {/each}
    {:catch err}
        <p>{err}</p>
    {/await}
    <BackDrop visible={showModalAdd} style="position: fixed">
        <Modal
            style="max-height: calc(80% - 90px); height: auto; margin: 80px 0 0 0"
            title="Agregar empleado"
            on:close={(_) => {
                showModalAdd = false
                editable = false
            }}
            on:clickout={(_) => {
                showModalAdd = false
                editable = false
            }}
        >
            <Empleado bind:data={formData} bind:validations signup editable />
            <svelte:fragment slot="buttonSet">
                <Button disabled={!validForm || loading} on:click={sendEmploye}
                    >Agregar</Button
                >
            </svelte:fragment>
        </Modal>
    </BackDrop>
    <BackDrop visible={showModalEmploye} style="position: fixed">
        <Modal
            style="max-height: calc(80% - 90px); height: auto; margin: 80px 0 0 0"
            title="Empleado"
            on:close={(_) => {
                showModalEmploye = false
                editable = false
            }}
            on:clickout={(_) => {
                showModalEmploye = false
                editable = false
            }}
        >
            <Empleado
                options={currentEmpleado.lfstate === 'Habilitado'}
                bind:data={currentEmpleado}
                {editable}
                bajaPermanenteHandler={sendBajaPermanente}
            />
            <svelte:fragment slot="buttonSet">
                {#if currentEmpleado.lfstate === 'Habilitado'}
                    {#if editable}
                        <Button
                            disabled={loading}
                            type="other"
                            on:click={() => {
                                editable = false
                                currentEmpleado =
                                    structuredClone(auxEmployeData)
                            }}>Cancelar</Button
                        >
                        <Button
                            disabled={!(
                                (changeFormData || updateDocs) &&
                                validData
                            ) || loading}
                            on:click={updateEmploye}>Guardar</Button
                        >
                    {:else}
                        <Button
                            disabled={loading}
                            on:click={toggleEmployeStatus}
                            type="secondary"
                            >{currentEmpleado.active
                                ? 'Desactivar'
                                : 'Reactivar'}</Button
                        >
                        <Button
                            disabled={loading}
                            on:click={() => (editable = true)}>Editar</Button
                        >
                    {/if}
                {/if}
            </svelte:fragment>
        </Modal>
    </BackDrop>
</div>

<style>
    .dg {
        width: 100%;
        position: relative;
        height: 250px;
        padding: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 20px;
    }
    .title {
        width: 100%;
        margin: 25px 0 30px 0;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
    }
    .title span {
        display: flex;
        gap: 10px;
        flex-direction: column;
        justify-content: center;
    }
    .container {
        min-height: fit-content;
        /* min-height: calc(100vh - 70px); */
        width: auto-fit;
        grid-template-columns: repeat(auto-fit, 375px);
        grid-template-rows: repeat(auto-fill, minmax(115px, 1fr));
        grid-gap: 30px;
        align-items: center;
        margin: 0 0 75px 0;
        /* justify-content: center; */
        display: grid;
        position: relative;
    }
</style>
